import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../static/css/ForgotPassword.css';
import logo from '../static/images/images/a-logo-transperent.png';

class ForgotPassword extends Component {
    constructor() {
        super();
        this.state = {
            email: '',
            submitting: false,
            sent: false,
            error: '',
        };
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onChangeEmail(e) {
        this.setState({ email: e.target.value, error: '' });
    }

    isFormValid() {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email);
    }

    async onSubmit(e) {
        e.preventDefault();
        if (!this.isFormValid() || this.state.submitting) return;
        this.setState({ submitting: true, error: '' });
        try {
            await axios.post(
                process.env.REACT_APP_SERVER_API + '/auth/web-forgot-password',
                { email: this.state.email.trim() }
            );
            this.setState({ submitting: false, sent: true });
        } catch (err) {
            this.setState({ submitting: false, error: 'Something went wrong. Please try again.' });
        }
    }

    render() {
        const { email, submitting, sent, error } = this.state;
        const valid = this.isFormValid();
        const buttonDisabled = !valid || submitting;
        return (
            <div className="forgot-password-container">
                <div className="animates-logo-container">
                    <Link to="/"><img className="animates-logo hover" style={{width: "125px"}} src={logo} alt="" /></Link>
                    <div className="welcomecs-header-auth-links">
                        <Link to="/signin" className="welcomecs-header-auth-link">Sign In</Link>
                    </div>
                </div>
                <h2 className="color-2 forgot-password-title" style={{fontFamily: "'Chelsea Market', cursive"}}><u>Forgot Password</u></h2>

                {sent ? (
                    <div className="forgot-password-sent-card">
                        <div className="forgot-password-check-icon">✓</div>
                        <h3 className="forgot-password-sent-title" style={{fontFamily: "'Chelsea Market', cursive"}}>Check your inbox</h3>
                        <p className="forgot-password-sent-message">
                            If this email address is associated with an account, instructions to reset your password will be sent to you. The email may take a minute or two to arrive.
                        </p>
                        <p className="forgot-password-sent-hint">
                            The reset link will expire in 15 minutes.
                        </p>
                        <Link to="/signin" className="forgot-password-back-link">Back to Sign In</Link>
                    </div>
                ) : (
                    <>
                        {error && <p className="forgot-password-error">{error}</p>}
                        <form className="forgot-password-form" onSubmit={this.onSubmit}>
                            <p className="forgot-password-intro">
                                Enter the email address you used to sign up. We'll send you a link to reset your password.
                            </p>
                            <label className="forgot-password-form-label" htmlFor="forgot-password-email">Email</label>
                            <input
                                id="forgot-password-email"
                                type="email"
                                className="forgot-password-form-input"
                                value={email}
                                onChange={this.onChangeEmail}
                                autoComplete="email"
                            />
                            <button type="submit" className="forgot-password-form-submit" disabled={buttonDisabled}>
                                {submitting ? 'Sending…' : 'Send Reset Link'}
                            </button>
                        </form>
                        <div className="forgot-password-signin-prompt">
                            <span>Remember your password?</span>
                            <Link to="/signin" className="forgot-password-signin-prompt-link">Sign In</Link>
                        </div>
                    </>
                )}
                <p className="forgot-password-footer">© 2026 AniMates. All rights reserved.</p>
            </div>
        );
    }
}

export default ForgotPassword;
